import React from 'react'
import { Helmet } from 'react-helmet-async'
import { MediaUsageLayout } from '../../layouts/Analytics'
import type { AnalyticsAPIResponse } from '../../interfaces'

interface Props {
  data: AnalyticsAPIResponse | null
  dateRange?: {
    startDate: Date
    endDate: Date
  }
  viewType?: 'grid' | 'table'
}

const MediaUsagePage = ({ data, dateRange, viewType }: Props): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Media Usage</title>
      <meta name="description" content="Media Usage page" />
    </Helmet>
    <MediaUsageLayout {...{ data, dateRange, viewType }} />
  </React.Fragment>
)

export default MediaUsagePage
